export const headerConfigs = {
  credentials: "same-origin",
  headers: {
    "Content-Type": "application/json",
    "X-Requested-With": "xmlhttprequest",
  },
};

export const endpoints = {
  cart: "/cart.js",
  update: "/cart/update.js",
  add: "/cart/add.js",
  change: "/cart/change.js",
};
